export const actionType = {
  HANDLE_LOGIN: "HANDLE_LOGIN",
  HANDLE_AUTHENTICATION: "HANDLE_AUTHENTICATION",
  LOADING: "LOADING",
  LOGOUT: "LOGOUT",
  ACTION_FRM: "ACTION_FRM",
  CLOSE_CHECKIN: "CLOSE_CHECKIN",
  CLOSE_CHECKOUT: "CLOSE_CHECKOUT",
};

export const interactionType = {
  OPEN_CLOSE_MENU: "OPEN_CLOSE_MENU",
  PHOTO_CHANGE: "PHOTO_CHANGE",
  PAY_MENU: "PAY_MENU",
  PAY_MENU_NEW: "PAY_MENU_NEW",
  SUCCESSFULL_PAYMENT: "SUCCESSFULL_PAYMENT",
  NOTIFICATION_DRAWER: "NOTIFICATION_DRAWER",
  NOTIFICATION_NUMBER: "NOTIFICATION_NUMBER",
  OPEN_CLOSE_LEAVE_FORM: "OPEN_CLOSE_LEAVE_FORM",
};
